namespace $.$$ {

	type $shm_echarts_type = 'line' | 'bar' | 'scatter' | 'pie'

	export class $shm_hitalama_map_widget_float_settings_echarts extends $.$shm_hitalama_map_widget_float_settings_echarts {

		@ $mol_mem
		chart() {
			return this.controlled_widget().chart()!
		}

		@ $mol_mem
		table_head() {
			return this.chart().table_head()
		}

		axis( next?: string ) {
			return this.chart().axis( next )
		}

		values( next?: ( any )[] ): readonly ( any )[] {
			return this.chart().values( next )
		}

		values_title( next?: string ) {
			return this.chart().values_title( next )
		}

		groups( next?: ( any )[] ): readonly ( any )[] {
			return this.chart().groups( next )
		}

		axis_details_visible() {
			return this.axis() == 'Дата' ? super.axis_details_visible() : []
		}

		@ $mol_mem
		axis_details( next?: string ): string {
			return this.chart().date_axis_details( this.axis(), next )
		}

		setting< Value >( name: string, next: Value | undefined, fallback: Value ): Value {
			const prev = ( this.controlled_widget().data() ?? {} ) as Record< string, Value >
			if( next === undefined ) return prev[ name ] ?? fallback

			this.controlled_widget().data({ ... prev, [ name ]: next })
			return next
		}

		chart_type( next?: string ): $shm_echarts_type {
			return this.setting( 'chart_type', next as $shm_echarts_type | undefined, 'line' )
		}

		legend_show( next?: boolean ) {
			return this.setting( 'legend_show', next, true )
		}

		smooth( next?: boolean ) {
			return this.setting( 'smooth', next, false )
		}

		area( next?: boolean ) {
			return this.setting( 'area', next, false )
		}

		stacked( next?: boolean ) {
			return this.setting( 'stacked', next, false )
		}

		toolbox_show( next?: boolean ) {
			return this.setting( 'toolbox_show', next, true )
		}

		data_zoom_show( next?: boolean ) {
			return this.setting( 'data_zoom_show', next, false )
		}

	}

}
